/**
 * Crew mutations (call sheet). Each goes through a `Mutate` (error toast + bundle refresh); the
 * server keeps cameras and people in step (apps/server/src/services/crew.ts).
 */
import type { CrewJob, Id, MissionBundle, Role } from '@apos/shared';
import { api, type PersonInput } from '../../lib/api';
import { liveMutate, type Mutate } from '../setup/mutate';

export function crewActions(bundle: MissionBundle, mutate: Mutate = liveMutate) {
  const mid = bundle.mission.id;
  return {
    setJob: (personId: Id, job: CrewJob | null) => mutate('set the job', () => api.people.update(mid, personId, { job })),
    setPlace: (personId: Id, locationId: Id | null) => mutate('set the place', () => api.people.update(mid, personId, { locationId })),
    /** Give a camera to someone (null = nobody; a Manned camera always needs someone). */
    giveCamera: (cameraId: Id, personId: Id | null) => mutate('assign the camera', () => api.cameras.update(mid, cameraId, { personId })),
    save: (personId: Id, p: PersonInput) => mutate('save', () => api.people.update(mid, personId, p)),
    add: (p: PersonInput & { name: string }) => mutate('add the person', () => api.people.create(mid, p)),
    remove: (personId: Id) => mutate('remove the person', () => api.people.remove(mid, personId).then(() => true)),
    link: (personId: Id, userId: Id) => mutate('link the person', () => api.people.link(mid, personId, userId)),
    setAccess: (userId: Id, role: Role) => mutate('change app access', () => api.missions.updateMember(mid, userId, { role })),
  };
}
export type CrewActions = ReturnType<typeof crewActions>;
